import React ,{useState,useEffect} from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import "./privacy.css";

import Preloader from '../Preloder/Preloader';
const Refund = () => {
   const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      // Simulate an API call or page load (set loading to false after 2 seconds or when content is fully loaded)
      const timer = setTimeout(() => {
        setLoading(false);
      }, 2000); // Adjust this delay as needed
      window.scrollTo(0, 0); // Scroll to the top of the page when the component is mounted
  
      return () => clearTimeout(timer); // Cleanup on component unmount
    }, []); // Empty dependency array ensures it runs only once on component mount
  
  return (
    <div>
       {loading && <Preloader />}
      <Header />

      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage:
              'url("assets/images/backgrounds/page-header-bg-1-1.jpg")',
          }}
        ></div>
        <div className="container">
          <h2 className="page-header__title">Refund Policy</h2>
          <ul className="cleenhearts-breadcrumb list-unstyled">
            <li>
              <i className="icon-home"></i> <Link to="/">Home</Link>
            </li>
            <li>
              <span>Login</span>
            </li>
          </ul>
        </div>
      </section>
        <div className="privacycontant">
            
            <h1>We do not provide any refund for any of our services.</h1>
        </div>
      
      <Footer />
    </div>
  );
};

export default Refund;
